<template>
    <!-- types -->
    <app-collapse
      accordion
      :type="'margin'"
    >
      <div class="d-flex align-items-center">
        <b-avatar
          rounded
          size="32"
          variant="light-danger"
          class="mr-75"
        >
          <feather-icon
            icon="MessageSquareIcon"
            size="16"
          />

        </b-avatar>
        <div>
          <h4 class="mb-0 page-title">
            FAQ
          </h4>
          <b-link @click="detail()" class="title"><feather-icon
            icon="ArrowLeftIcon"
            size="16"
            style="margin-bottom:0.3rem;"
          />{{title}}</b-link>
        </div>
      </div>


      <app-collapse-item v-show="isLoading" v-for="i in 10" :key="i">
        <template #header>
          <div class="skeleton-box" :style="`width: ${Math.floor(Math.random() * (5 - 3 + 1) + 3)}0%; height: 15px;`" />
        </template>
        <SkeletonContainer />
      </app-collapse-item>

      <app-collapse-item v-for="(data, index) in faqs" :key="index" :title="data.title">
        <div v-html="data.content"></div>
      </app-collapse-item>

      <b-card v-if="!faqs || !faqs.length && !isLoading" class="text-center no-data" title="No data FAQ for this Product">
      </b-card>
    </app-collapse>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import {
  BCard, BCardText,BLink,BAvatar,BRow,BCol
} from 'bootstrap-vue'
import SkeletonContainer from './components/SkeletonContainer.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BAvatar,
    BLink,
    AppCollapse,
    AppCollapseItem,
    BCardText,
    SkeletonContainer
  },
  data() {
    return {
      collapseType: 'default',
      title: null,
      faqs: [],
      isLoading: false
    }
  },
  created() {
    const mapRequest = {
      map: {
        PRODUCT: 'd',
        faqs : 'd'
      }
    }
    this.isLoading = true
    this.$http.post('/product/browse/id/'+this.$route.params.key+'/set/first/published/true', mapRequest).then(response => { 
      this.$store.commit('app/SET_PAGE_TITLE',response.data.data.records.PRODUCT)
      this.title = response.data.data.records.PRODUCT
      this.faqs = response.data.data.records.faqs
    })
    .finally(() => {
      this.isLoading = false
    })
  },
  methods: {
    detail(){
      const routeName = this.$route?.name || ''
      const rootText = this.$route?.meta?.breadcrumb?.[0]?.text || ''
      if (routeName.includes('bundling') || rootText === 'Product Bundling') {
        this.$router.push({name : 'product-bundling-detail', params:{key:this.$route.params.key}})
      } else if(this.$route.meta.breadcrumb[1].text == 'Communication'){
        this.$router.push({name : 'product-communication-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Datacomm'){
        this.$router.push({name : 'product-datacomm-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Internet'){
        this.$router.push({name : 'product-internet-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Wireless'){
        this.$router.push({name : 'product-wireless-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'CONS'){
        this.$router.push({name : 'product-cfu-cons-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'EBIS'){
        this.$router.push({name : 'product-cfu-ebis-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'WIBS'){
        this.$router.push({name : 'product-cfu-wibs-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Segmentation'){
        this.$router.push({name : 'product-segmentation-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Targeting'){
        this.$router.push({name : 'product-targeting-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Cyber Security'){
        this.$router.push({name : 'product-cyber-security-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Fitur'){
        this.$router.push({name : 'product-fitur-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Produk'){
        this.$router.push({name : 'product-produk-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Varian'){
        this.$router.push({name : 'product-varian-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'DTP'){
        this.$router.push({name : 'product-dtp-detail', params:{key:this.$route.params.key}})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.skeleton-box {
  display: inline-block;
  height: 1em;
  position: relative;
  overflow: hidden;
  background-color: #DDDBDD;
  border-radius: 8px;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0) 0,
      rgba(#fff, 0.2) 20%,
      rgba(#fff, 0.5) 60%,
      rgba(#fff, 0)
    );
    animation: shimmer 2s infinite;
    content: '';
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>

<style>
.b-avatar.badge-light-danger {
  background-color: red;
  color: white
}

.title {
  color:black;
}

.no-data > .card-body{
  padding:1rem !important;
}

.no-data > .card-body > .card-title{
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1.2em;
  color: gray;
}

@media (max-width: 767px) {
  .page-title {
    font-size: 1.4rem;
  }
}
</style>
